import firebase from "firebase/app";
import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyDuKiT9afndT63hn-nGpDhqFKHxoZsXQT4",
  authDomain: "dscvr-2561c.firebaseapp.com",
  databaseURL: "https://dscvr-2561c.firebaseio.com",
  projectId: "dscvr-2561c",
  storageBucket: "dscvr-2561c.appspot.com",
  messagingSenderId: "158570475462",
  appId: "1:158570475462:web:202485d038ad8123b44cc7"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

export default db;
